import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "fixed w-screen h-screen bg-modal-overlay top-0 left-0 z-40 bg-opacity-50 sm:hidden" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "text-12 text-input-danger mt-2"
}
const _hoisted_3 = {
  key: 1,
  class: "text-input-danger text-12 mt-2"
}
const _hoisted_4 = {
  key: 2,
  class: "text-input-danger text-12 mt-2"
}
const _hoisted_5 = { class: "text-center md:text-right mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSelect = _resolveComponent("BaseSelect")
  const _component_SearchPlatformCheckbox = _resolveComponent("SearchPlatformCheckbox")
  const _component_router_link = _resolveComponent("router-link")
  const _component_BaseButton = _resolveComponent("BaseButton")
  const _component_BaseCard = _resolveComponent("BaseCard")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_BaseCard, { class: "py-8 px-9 shadow-dropdown z-50 relative border border-secondary-light" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseSelect, {
          modelValue: _ctx.localValue.language,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localValue.language = $event)),
          class: "mb-4",
          label: _ctx.$t('dashboard.text-search-area.advanced-settings.languages.label'),
          tooltip: _ctx.$t('dashboard.text-search-area.advanced-settings.languages.description'),
          items: _ctx.languageOptions
        }, null, 8, ["modelValue", "label", "tooltip", "items"]),
        _createVNode(_component_SearchPlatformCheckbox, {
          modelValue: _ctx.selectedDatabases,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedDatabases = $event)),
          class: "mt-10 mb-6",
          label: _ctx.$t('dashboard.text-search-area.advanced-settings.platform-to-search-on.label'),
          tooltip: _ctx.$t('dashboard.text-search-area.advanced-settings.platform-to-search-on.description'),
          options: _ctx.platformOptions,
          supported: _ctx.supportedSources,
          "checkbox-classes": "flex items-center"
        }, null, 8, ["modelValue", "label", "tooltip", "options", "supported"]),
        (_ctx.isMaxSelected)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.$t('messages.max-databases')) + " ", 1),
              _createVNode(_component_router_link, {
                class: "text-link font-semibold",
                to: { name: 'membership' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('actions.upgrade-now')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedDatabases.length === 0)
          ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('errors.platform-required')), 1))
          : _createCommentVNode("", true),
        (_ctx.isError.length === 0)
          ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('errors.system')), 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_BaseButton, {
            class: "mr-2 uppercase",
            outline: "",
            onClick: _ctx.onCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('actions.cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_BaseButton, {
            variant: "success",
            class: "uppercase",
            loading: _ctx.isLoading,
            onClick: _ctx.onApply
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('actions.apply')), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]),
      _: 1
    })
  ]))
}